export default function (to, from, savedPosition) {
  if (savedPosition) {
    $nuxt.$store.commit('pages/setCurrentRoutePath', to.path)
    return savedPosition
  } else if (to.path.includes("news/")) {
    $nuxt.$store.commit('pages/setCurrentRoutePath', to.path)
    return false
  } else {
    // scroll to top AFTER from-page has faded out but BEFORE to-page fades in
    return new Promise((resolve) => {
      $nuxt.$root.$once('page-after-leave', () => {
        // the from-page has now faded out, so let's scroll to top before the to-page fades in
        $nuxt.$nextTick(() => {
          resolve({
            x: 0,
            y: 0,
          });
          // save current path AFTER we reset scroll position, to prevent the W-Storylink Vue.ScrollToTop function to run before the page animation has happened
          $nuxt.$store.commit('pages/setCurrentRoutePath', to.path)
        });
      });
    });
  }
}
